<template>
  <div class="paper-student-preview-not-match">
    <TemplateDataGrid gridId="PePaperStudentQueryNotMatch" v-bind="gridParams"></TemplateDataGrid>
  </div>
</template>

<script>
import TemplateDataGrid from '../../../../../../../templates/TemplateDataGrid'
export default {
  name: 'PaperStudentPreviewNotMatch',
  components: {
    TemplateDataGrid
  },
  props: {
    gridParams: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
.paper-student-preview-not-match {
  height: 100%;
}
</style>
